import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {withStyles} from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';

import {http, api} from '../common/common';

const styles = (theme) => {
    return {
        progressContainer: {
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            width: 200,
            height: 95,
            margin: 'auto',
        },
        progress: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            width: 80,
            height: 80,
            marginLeft: 'auto',
            marginRight: 'auto',
            color: theme.palette.primary.light,
        },
        progressText: {
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
        },
    };
}

class PreLogin extends Component {
    constructor(props) {
        super(props);

        this._cancelToken = http.CancelToken.source();
    }

    componentWillUnmount = () => {
        if (this._cancelToken) {
            this._cancelToken.cancel();
        }
    }

    render = () => {
        this._requestLogin();

        const {classes} = this.props;

        return (
            <div className={classes.progressContainer}>
                <CircularProgress
                    className={classes.progress}
                    size={60}
                />
                <Typography
                    className={classes.progressText}
                    align='center'
                >
                    Loading Application...
                </Typography>
            </div>
        );
    }

    _done = () => {
        if (this.props.onDone) {
            this.props.onDone();
        }
    }

    _requestLogin = async () => {
        try {
            const response = await http.get(api.profile() + '/login-info', {
                params: {
                    'access_code': this.props.getAccessCode(),
                },
                cancelToken: this._cancelToken.token,
            });

            if (response.data) {
                this._lastLogin = response.data.last_login
            }

            this._done();
        } catch (error) {
            if (http.isCancel(error)) {
                return;
            }

            this._done();
        }
    }
}

PreLogin.propTypes = {
    setError: PropTypes.func.isRequired,
    getAccessCode: PropTypes.func.isRequired,
    sharedProps: PropTypes.object.isRequired,
    setSharedProps: PropTypes.func,
    onDone: PropTypes.func,
    onError: PropTypes.func,
}

export default withStyles(styles)(PreLogin);
